module.exports = __webpack_public_path__ + "assets/img/avatar.0a248b20.png";